import Grid from '@mui/material/Grid';
import { createTheme, ThemeProvider } from "@mui/material/styles";
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import useMyMApi from "../../hooks/useMyMApi";
import { MyMModal } from '../../ui-elements/MyMModal';
import { MyMProgress } from '../../ui-elements/MyMProgress';
import Preview, { previewModalSize } from '../MyM906_Preview/Preview';
import { HomeBusinessAreaCard } from './HomeBusinessAreaCard';
import { HomeLatestHcmSocialPostsCard } from './HomeLatestHcmSocialPostsCard';
import { HomeMiningNewsCard } from './HomeMiningNewsCard';
import { HomeMyFavoriteDocumentApplicationCard } from './HomeMyFavoriteDocumentApplicationCard';
import { HomeSurveyReminder } from './HomeSurveyReminder';
import { HomeWelcomeMessageCard } from './HomeWelcomeMessageCard';
import { HomeWhatNewCard } from './HomeWhatNewCard';

// 2024.9.16 MyMine Version2.0対応 Modify Start
const zoomRatio = Number(getComputedStyle(document.body).getPropertyValue('--zoom-ratio'));
const breakpointAdjustValue = zoomRatio < 0.8 ? 300 : 0;
const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600 - breakpointAdjustValue,
      md: 900 - breakpointAdjustValue,      
      lg: 1350 - breakpointAdjustValue,    
      xl: 1500 - breakpointAdjustValue,
      xxl: 2000 - breakpointAdjustValue,
    },
  },
})
// 2024.9.16 MyMine Version2.0対応 Modify End

/**
 * Home Page Component
 */
const Home = React.memo((props) => {
  const screenId = 'MyM102';
  const [homeData, setHomeData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [previewFileId, setPreviewFileId] = useState(false);
  const handleModalClose = () => setIsModalOpen(false);
  const apiRequest = useMyMApi(screenId);
  const location = useLocation();

  /**
   * プレビュー処理
   * @param {Event} e イベント引数
   * @param {string} fileId ファイルID
   */
  const onClickPreview = (e, fileId) => {
    setPreviewFileId(fileId);
    setIsModalOpen(true);
  }

  useEffect(() => {
    const fileIdFromState = location.state?.previewFileId;
    if (fileIdFromState) {
      setPreviewFileId(fileIdFromState);
      setIsModalOpen(true);
    }
  }, [location.state]);

  useEffect(() => {
    const callbackHomeContext = (result) => {
      setHomeData(result);
    }
    apiRequest.requestJson('api/home/load', 'GET', callbackHomeContext)
  }, []);

  if (homeData === null)
    return <MyMProgress />

  return (
    <ThemeProvider theme={theme}>
      {isLoading && <MyMProgress />}
      <Grid container spacing={1} className="mt-0 pb-3" sx={{ padding: "0px 5px 0px 5px" }} >

        <Grid item xs={12} md={2.5}  sx={{ height: "350px" }}>
          <HomeWelcomeMessageCard screenId={screenId} />
        </Grid>

        <Grid item xs={12} md={9.5} sx={{ height: "350px" }}>
          <HomeBusinessAreaCard screenId={screenId} />
        </Grid>

        <Grid item xs={12} md={2.5} >
          <HomeWhatNewCard screenId={screenId} boxFile={homeData.BoxFileList} onPreview={onClickPreview} />
        </Grid>

        <Grid item xs={12} md={3.5}>
          <HomeMyFavoriteDocumentApplicationCard
            screenId={screenId}
            favoriteBoxFile={homeData.FavoriteBoxFileList}
            favoriteItApp={homeData.FavoriteItAppList}
            onPreview={onClickPreview}
            apiRequest={apiRequest}
          />
        </Grid>

        <Grid item xs={12} md={3}>
          <HomeMiningNewsCard screenId={screenId} miningNews={homeData.NewsList} setIsLoading={setIsLoading} apiRequest={apiRequest} />
        </Grid>

        <Grid item xs={12} md={3}>
          <HomeLatestHcmSocialPostsCard />
        </Grid>

        <MyMModal
          open={isModalOpen}
          onClose={handleModalClose}
          {...previewModalSize}
        >
          <Preview fileId={previewFileId} onPreviewFailed={handleModalClose} />
        </MyMModal>
      </Grid>
      {/* 2025.7.7 MyMine Version3.0対応 Add Start */}
      <HomeSurveyReminder screenId={screenId} />
      {/* 2025.7.7 MyMine Version3.0対応 Add End */}
    </ThemeProvider>
  );
})
export default Home;